import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'nimbus-grid-pager',
  templateUrl: './nimbus-grid-pager.component.html',
  styleUrls: ['./nimbus-grid-pager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NimbusGridPagerComponent implements OnChanges {
  @ViewChild(MatPaginator, { static: true })
  private paginator: MatPaginator;

  @HostBinding('class')
  public className: string = 'nimbus-grid-pager';

  @Input()
  @HostBinding('class.hide-range-label')
  public hideRangeLabel: boolean = false;

  @Input()
  public total: number;
  @Input()
  public pageIndex: number = 0;
  @Input()
  public pageSize: number;
  @Input()
  public buttonCount: number;
  @Input()
  public showFirstLastButtons: boolean;

  @Output()
  public pageIndexChange = new EventEmitter<PageEvent>();

  public buttons: number[];
  public end: number;
  public start: number;
  public totalPages: number;

  public get isLazyLoadingEnabled(): boolean {
    return this.total === Infinity;
  }

  public constructor(public wrapper: ElementRef) {}

  public ngOnChanges(e: SimpleChanges): void {
    if (e.pageSize || e.total || e.buttonCount || e.pageIndex) {
      this.bind();
    }
  }

  public pageChange(event: PageEvent): void {
    this.total = event.length;
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.bind();

    this.pageIndexChange.next(event);
  }

  public changePageIndex(pageIndex: number): void {
    const event: PageEvent = {
      length: this.paginator.length,
      pageIndex,
      pageSize: this.paginator.pageSize,
    };

    this.paginator.page.next(event);
  }

  private bind(): void {
    const buttons = [];
    const pageCurrent = this.pageIndex + 1;
    let start = 1;

    if (pageCurrent > this.buttonCount) {
      const reminder = pageCurrent % this.buttonCount;
      start = reminder === 0 ? pageCurrent - this.buttonCount + 1 : pageCurrent - reminder + 1;
    }

    const totalPages = Math.ceil((this.total || 0) / this.pageSize);
    const end = Math.min(start + this.buttonCount - 1, totalPages);

    for (let button = start; button <= end; button++) {
      buttons.push(button);
    }

    this.end = end;
    this.start = start;
    this.buttons = buttons;
    this.totalPages = totalPages;
  }
}
